var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _vm.out_of_date
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row div-message" }, [
              _c("div", { staticClass: "col-md-12 text-message" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("system_out_of_date")
                      )
                    ) +
                    "\n        "
                )
              ])
            ])
          ])
        : _c("div", [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "row div-message" }, [
              _c("div", { staticClass: "col-md-12 text-message" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("system_updated")
                      )
                    ) +
                    "\n        "
                )
              ])
            ])
          ]),
      _vm._v(" "),
      _vm.out_of_date
        ? _c("div", { staticClass: "row update-options" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-block",
                  attrs: { type: "button", id: "btn-cancel" },
                  on: { click: _vm.updateFromCloud }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("translate")("update_from_cloud")
                        )
                      ) +
                      "\n        "
                  )
                ]
              )
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", id: "btn-cancel" },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("close"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row div-message" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("i", { staticClass: "fa fa-calendar-times-o icon-out-of-date" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row div-message" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("i", { staticClass: "fa fa-calendar-check-o icon-updated" })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cbf30bac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbf30bac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/configuration/Update.vue
// module id = 461
// module chunks = 0 1 71 162